import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
    // Actualizar clase en el HTML para que Tailwind pueda usarlo
    if (isDark) {
      document.documentElement.classList.add('dark');
      document.documentElement.classList.remove('light');
    } else {
      document.documentElement.classList.add('light');
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);

  const toggleTheme = () => setIsDark(!isDark);

  const theme = {
    isDark,
    toggleTheme,
    // Colores dinámicos
    bg: isDark ? 'bg-[#050505]' : 'bg-gray-50',
    bgCard: isDark ? 'bg-[#0a0a0a]' : 'bg-white',
    bgSidebar: isDark ? 'bg-black' : 'bg-white',
    text: isDark ? 'text-white' : 'text-gray-900',
    textSecondary: isDark ? 'text-gray-400' : 'text-gray-600',
    border: isDark ? 'border-white/10' : 'border-gray-200',
    card: isDark ? 'bg-white/5 border-white/10' : 'bg-white border-gray-200 shadow-sm',
    cardHover: isDark ? 'hover:bg-white/10' : 'hover:bg-gray-50',
    input: isDark ? 'bg-white/5 border-white/10 text-white' : 'bg-white border-gray-300 text-gray-900',
    sidebar: isDark ? 'bg-black border-white/10' : 'bg-white border-gray-200 shadow-lg',
    sidebarItem: isDark ? 'hover:bg-white/10' : 'hover:bg-gray-100',
    sidebarActive: isDark ? 'bg-white/10 text-white' : 'bg-ai-glow/10 text-ai-glow',
    dropdown: isDark ? 'bg-[#1a1a1a] border-white/10' : 'bg-white border-gray-200 shadow-lg',
    tableHeader: isDark ? 'bg-white/5' : 'bg-gray-100',
    tableRow: isDark ? 'hover:bg-white/5' : 'hover:bg-gray-50',
    modal: isDark ? 'bg-[#111] border-white/10' : 'bg-white border-gray-200',
    overlay: isDark ? 'bg-black/80' : 'bg-black/50',
    scrollbar: isDark ? 'scrollbar-dark' : 'scrollbar-light',
    glassCard: isDark 
      ? 'bg-gradient-to-br from-white/[0.05] to-white/[0.02] border border-white/10 backdrop-blur-xl' 
      : 'bg-white border border-gray-200 shadow-md',
  };

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};
